module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_ListofIllustration"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Author"
    }
  }, [_vm._v("Also by the same author")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapalb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Part01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART I: THE BRILLIANT BUT DEVIOUS SECRETARY")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 1")]), _vm._v(" Maitland establishes his standing under Mary of Guise")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter02"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 2")]), _vm._v(" The Lords of the Congregation challenge French authority")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 3")]), _vm._v(" The return of the widowed Mary Queen of Scots")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 4")]), _vm._v(" Diplomatic efforts to establish Mary as Elizabeth’s heir")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 5")]), _vm._v(" Lord James (soon to be Earl of Moray) and Maitland establish authority")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 6")]), _vm._v(" The negotiations for Mary’s remarriage")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapalb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART II: MARY TAKES PERSONAL CONTROL")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 7")]), _vm._v(" Mary’s efforts to take up the reins of government")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 8")]), _vm._v(" Marriage to Darnley")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 9")]), _vm._v(" Moray’s rebellion")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapalb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART III: MAITLAND RE-ESTABLISHES HIS STANDING")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 10")]), _vm._v(" Riccio’s murder")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 11")]), _vm._v(" Restored as Secretary of State")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 12")]), _vm._v(" Ending Mary’s marriage to Darnley")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapalb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART IV: DEVELOPING THE TALE OF A CRIME OF PASSION")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 13")]), _vm._v(" The Chameleon")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 14")]), _vm._v(" The plot for Darnley’s murder unfolds")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 15")]), _vm._v(" Providing evidence of a crime of passion")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 16")]), _vm._v(" Enticement for Mary to marry Bothwell")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 17")]), _vm._v(" Bothwell’s exoneration and marriage to Mary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapalb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART V: MARY’S ARREST AND MAITLAND’S CONTRITION")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 18")]), _vm._v(" The Confederates challenge Mary and Bothwell")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 19")]), _vm._v(" Negotiations while Mary is held at Lochleven")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 20")]), _vm._v(" Mary’s escape and Maitland’s signs of sympathy")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 21")]), _vm._v(" The Conferences at York and Westminster")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 22")]), _vm._v(" A last hurrah for Mary’s cause")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Biolography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Reference",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0